"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageActionStatusEnum = void 0;
var MessageActionStatusEnum;
(function (MessageActionStatusEnum) {
    MessageActionStatusEnum["PENDING"] = "pending";
    MessageActionStatusEnum["DONE"] = "done";
})(MessageActionStatusEnum = exports.MessageActionStatusEnum || (exports.MessageActionStatusEnum = {}));
